import app from 'flarum/forum/app';
import Component from 'flarum/common/Component';
import Button from 'flarum/common/components/Button';
export default class SocialAccountItem extends Component {
  loading = false;
  view() {
    const linked = Boolean(app.forum.attribute(this.attrs.linkedAttribute));
    const configured = Boolean(app.forum.attribute(this.attrs.configuredAttribute));
    const linkingAllowed = Boolean(app.forum.attribute(this.attrs.linkingAttribute));
    if (!configured) {
      return null;
    }
    return m("div", {
      className: `DevConnectSocialAccount DevConnectSocialAccount--${this.attrs.provider}`
    }, m("div", {
      className: "DevConnectSocialAccount-info"
    }, m("i", {
      className: this.attrs.icon,
      "aria-hidden": "true"
    }), m("span", null, m("strong", null, this.attrs.title), m("small", null, linked ? this.attrs.linkedText : this.attrs.notLinkedText))), linked ? m(Button, {
      className: "Button Button--danger",
      loading: this.loading,
      onclick: () => this.disconnect()
    }, this.attrs.disconnectText) : m(Button, {
      className: "Button Button--primary",
      disabled: !linkingAllowed,
      onclick: () => this.connect()
    }, this.attrs.connectText));
  }
  connect() {
    const returnTo = `${app.forum.attribute('baseUrl')}/settings`;
    window.location.assign(`/auth/${this.attrs.provider}?action=link&return=${encodeURIComponent(returnTo)}`);
  }
  async disconnect() {
    if (!window.confirm(this.attrs.disconnectConfirmText)) {
      return;
    }
    this.loading = true;
    try {
      await app.request({
        method: 'DELETE',
        url: `${app.forum.attribute('apiUrl')}/devconnect/oauth/${this.attrs.provider}`
      });
      app.forum.pushAttributes({
        [this.attrs.linkedAttribute]: false
      });
      app.alerts.show({
        type: 'success'
      }, this.attrs.disconnectedText);
    } catch (error) {
      const message = error?.response?.errors?.[0]?.detail || this.attrs.disconnectErrorText;
      app.alerts.show({
        type: 'error'
      }, message);
    } finally {
      this.loading = false;
      m.redraw();
    }
  }
}
flarum.reg.add('devconnect-oauth-yandex', '../../../devconnect-oauth-core/js/src/forum/components/SocialAccountItem', SocialAccountItem);